import React from 'react';
import MailIcon from 'presentation/common/components/style-guide/icons/MailIcon';
import PropTypes from "prop-types";
import {OutlineErrorIcon, WhatAppIcon} from "presentation/common/components/style-guide/icons";
import {Button} from "presentation/common/components";
import styles from './ErrorMessage.module.scss';
import clsx from "clsx";
import {emptyFn} from "presentation/common/helpers/utils";

export const ErrorMessageContent = (props) => {
  const inlineStyle = 'text-nowrap px-1 py-1 my-1';
  const inlineIcon = "inline-icon pr-1";
  const wrapRowStyle = 'flex flex-wrap justify-center';
  const iconColor = '#374151';
  const {message, email, title, Icon = OutlineErrorIcon, onClose, whatsapp, svgColor='#ff0f00'} = props;

  return (
    <div className={styles.container}>
      <div className="text-center mb-3"><Icon stroke={svgColor}/></div>
      <h3 className={clsx("text-lg text-center pt-1 pb-3", styles.title)}>{title}</h3>
      <p className={clsx("text-center pb-4", styles.message)}>{message}</p>
      <div style={{fontSize: '14px'}} className="pb-3">
        <div className={clsx(wrapRowStyle, styles.info)}>
          <span className={inlineStyle}>
            <span className={inlineIcon}>
              <MailIcon fontSize="small" fill='#fff' stroke={iconColor}/>
            </span>
            <a href={"mailto:" + email}>{email}</a>
          </span>
          {/*<span className="text-nowrap px-2 py-1 my-1">*/}
          {/*  <span className={inlineIcon}>*/}
          {/*    <PhoneIcon fontSize="small" fill={iconColor}/>*/}
          {/*  </span>*/}
          {/*  <span>{phone}</span>*/}
          {/*</span>*/}
          <span className={inlineStyle}>
            <span className={inlineIcon}>
              <WhatAppIcon fontSize="small" fill={iconColor}/>
            </span>
            <span>{whatsapp}</span>
          </span>
        </div>
      </div>
      <div className="text-center">
        <Button label="Aceptar" onClick={onClose}/>
      </div>
    </div>
  );
};

ErrorMessageContent.defaultProps = {
  title: '¡Ha ocurrido un error!',
  message: 'Intente nuevamente o contáctenos.',
  email: 'soporte-idauto@dox.cl',
  phone: '+56 1 2345 6789',
  whatsapp: '+56 999846063',
  onClose: emptyFn
};

ErrorMessageContent.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  whatsapp: PropTypes.string,
  onClose: PropTypes.func
};

export default React.memo(ErrorMessageContent);
